/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.17.0
 * @since 1.15.0
 */

import { IPageOrderIdTranslation } from '../../types';

export const initPageOrderIdTranslation: IPageOrderIdTranslation = {
    contextHelp: {
        fileLoadSuccess: '',
        subsCountWithErrors: '',
    },
    file: {
        btn: '',
        reportNotAvailable: '',
    },
    fileModal: {
        start: {
            fields: {
                zip: '',
                zipPasswordOptional: '',
            },
            title: '',
        },
        success: {
            title: '',
        },
    },
    info: {
        date: '',
        status: {
            CONFIRM: '',
            CONFIRMED_PARTIALLY: '',
            ERROR: '',
            PROCESSING: '',
            REJECTED: '',
            REORDER: '',
            SUCCESS: '',
            SUCCESS_PARTIALLY: '',
            WAITING_CONFIRM: '',
            WAITING_PROCESSING: '',
        },
        statusLabel: '',
        user: '',
    },
    parameters: {
        autoReport: {
            day: '',
            deleteDay: '',
            month: '',
            time: '',
        },
        date: {
            isCurrent: '',
        },
        fields: {
            accessLevel: '',
            account: '',
            actionName: '',
            additionalAccounts: '',
            autoReport: '',
            bonus: '',
            dateFrom: '',
            dateFromMonth: '',
            dateFrontQuarter: '',
            dateTo: '',
            dateToMonth: '',
            dateToQuarter: '',
            externalService: '',
            favDirect: '',
            report: '',
            rules: '',
            sendParameters: '',
            service: '',
            simCardIccid: '',
            simCardPuk1: '',
            tariff: '',
            tariffOptions: '',
            tariffService: '',
            transferAmount: '',
            transferFrom: '',
            transferTo: '',
        },
        title: '',
    },
    subsErrors: {
        btn: '',
        placeholder: '',
        title: '',
    },
    subscriberList: {
        label: '',
        msisdn: '',
        msisdnNotAvailable: '',
        name: '',
        status: '',
    },
    title: '',
};
